/* Copyright CADS
 *
 * All rights are reserved. Reproduction or transmission in whole or in part, in
 * any form or by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 *
 * THIS FILE IS AUTO GENERATED DO NOT EDIT IT MANULLY
 *
 */

 // Generated index.ts file.
export * from './application-settings-data';
export * from './mobile-settings-data';
export * from './adal-b2c-data';
export * from './web-import';
export * from './web-command';
export * from './contract-tonnage-information';
export * from './customer-and-contract-tonnage-information';
export * from './depot-combined-data';
export * from './depot-site-customer-and-contract-tonnage-information';
export * from './scaffold-section-scaffold-data';
export * from './site-customer-and-contract-tonnage-information';
export * from './site-combined-data';
export * from './scaffold-system-data';
export * from './contract-system-data';
export * from './stock-report';
export * from './stock-report-customer-and-contract-section';
export * from './stock-report-depot-and-site-section';
export * from './stock-report-filter-section';
export * from './stock-report-scaffold-section';
export * from './stock-report-scaffold-subsection';
export * from './stock-report-record-for-csv';
export * from './scaffold-combined-data';
export * from './handover-report-input';
export * from './inspection-report-input';
export * from './variation-report-input';
export * from './report-input-guid-data';
export * from './report-input-guid-list-data';
export * from './application-payment-check-list-input';
export * from './cumulative-report-input';
export * from './defect-report-input';
export * from './handover-history-report-input';
export * from './handover-status-report-input';
export * from './individual-payroll-report-input';
export * from './payroll-report-input';
export * from './scaffold-report-input';
export * from './stock-report-input';
export * from './application-payment-activity-report-data';
export * from './application-payment-report-data';
export * from './site-diary-entry-application-payment-report-data';
export * from './scaffold-diary-entry-application-payment-report-data';
export * from './dimension-application-payment-report-data';
export * from './handover-application-payment-report-data';
export * from './inspection-application-payment-report-data';
export * from './scaffold-application-payment-report-data';
export * from './variation-application-payment-report-data';
export * from './company-details';
export * from './company-statistic-data';
export * from './configuration-query';
export * from './contact-type-data';
export * from './contract-type-data';
export * from './expense-type-data';
export * from './inspection-defect-status-type-data';
export * from './diary-category-data';
export * from './rate-type-data';
export * from './report-section-data';
export * from './roles-data';
export * from './scaffolding-system-type-data';
export * from './task-type-data';
export * from './inspection-status-data';
export * from './customer-attachment-data';
export * from './handover-settings-data';
export * from './staff-rate-data';
export * from './staff-rate-type-data';
export * from './time-entry-data';
export * from './time-entry-expense-data';
export * from './time-entry-hours-data';
export * from './time-entry-rate-data';
export * from './time-entry-staff-data';
export * from './time-entry-task-data';
export * from './timesheet-period-data';
export * from './timesheet-query';
export * from './timesheet-contract-data';
export * from './timesheet-data';
export * from './timesheet-depot-data';
export * from './timesheet-item-data';
export * from './timesheet-site-data';
export * from './timesheet-depots-query';
export * from './customer-query';
export * from './customer-detail-query';
export * from './customer-statistics-query';
export * from './customer-site-data';
export * from './customer-web-app-data';
export * from './customer-detail-web-app-data';
export * from './customer-statistics-data';
export * from './handover-history-query';
export * from './handover-history-web-app-data';
export * from './handover-statistics-data';
export * from './item-data';
export * from './item-details-data';
export * from './item-details-query';
export * from './quote-query';
export * from './quote-data';
export * from './quote-scaffold-data';
export * from './task-data';
export * from './unassigned-scaffold-query';
export * from './defect-statistics-query';
export * from './defect-statistic-data';
export * from './media-base-data';
export * from './media-transcription-data';
export * from './scaffold-statistics-data';
export * from './scaffold-status-statistics-data';
export * from './handover-identified-risk-data';
export * from './handover-data';
export * from './handover-handover-settings-data';
export * from './handover-statistics-query';
export * from './handover-settings-query';
export * from './handover-summary-data';
export * from './handover-risk-summary-data';
export * from './inspection-data';
export * from './configuration-data';
export * from './defect-type-data';
export * from './design-type-data';
export * from './handover-risk-reason-data';
export * from './handover-risk-type-data';
export * from './inspection-outcome-data';
export * from './inspection-type-data';
export * from './inspection-type-group-data';
export * from './loading-limit-data';
export * from './lookup-data-base';
export * from './methods-of-cladding-data';
export * from './method-of-tying-data';
export * from './scaffold-status-data';
export * from './contract-contact-data';
export * from './contract-data';
export * from './customer-signature-data';
export * from './media-data';
export * from './customer-status-data';
export * from './handover-question-data';
export * from './contract-status-data';
export * from './scaffold-type-data';
export * from './site-status-data';
export * from './off-hire-data';
export * from './dash-board-inspection-data';
export * from './handover-scaffold-data';
export * from './diary-data';
export * from './diary-query';
export * from './scaffold-detail-query';
export * from './scaffold-statistics-query';
export * from './site-dash-board-scaffold-inspection-data';
export * from './query';
export * from './inspection-defect-data';
export * from './inspection-defect-summary-data';
export * from './inspection-defect-web-app-data';
export * from './inspection-follow-up-instruction-data';
export * from './inspection-follow-up-notify-data';
export * from './scaffold-data';
export * from './scaffold-web-app-data';
export * from './dismantle-data';
export * from './scaffold-inspection-data';
export * from './scaffold-inspection-summary-data';
export * from './scaffold-inspection-web-app-data';
export * from './scaffold-item-data';
export * from './scaffold-item-dimensions-data';
export * from './scaffold-tag-data';
export * from './unsafe-scaffold-report-data';
export * from './site-area-data';
export * from './site-data';
export * from './application-user-data';
export * from './customer-data';
export * from './site-query';
export * from './site-detail-query';
export * from './site-scaffold-query';
export * from './site-contract-inspection-status-query';
export * from './scaffold-inspection-query';
export * from './site-statistics-query';
export * from './site-scaffold-diary-query';
export * from './site-scaffold-diary-data';
export * from './site-web-app-data';
export * from './site-statistics-data';
export * from './site-tonnage';
export * from './staff-signature-data';
export * from './staff-data';
export * from './staff-details-query';
export * from './staff-query';
export * from './staff-statistics-query';
export * from './staff-site-data';
export * from './staff-statistics-data';
export * from './staff-details-web-app-data';
export * from './timesheet-staff-data';
export * from './timesheet-task-data';
export * from './dimension-data';
export * from './variation-data';
export * from './variation-instruction-data';
export * from './scaffold-timeline-data';
export * from './scaffold-timeline-query';
export * from './depot-data';
export * from './depot-query';
export * from './activities-data';
export * from './activities-query';
export * from './activity-detail-data';
export * from './activity-detail-query';
export * from './contract-activity-details';
export * from './diary-activity-details';
export * from './dismantle-activity-details';
export * from './handover-activity-details';
export * from './handover-identified-risk-activity-data';
export * from './inspection-activity-details';
export * from './offhire-activity-details';
export * from './scaffold-details';
export * from './site-details';
export * from './variation-activity-details';
export * from './variation-instruction-activity-data';
export * from './site-diary-activity-details';
